import React, {useContext} from "react";
import {RecordsManagementContext} from "../StatesMangement/InitialiseContext";
import {Modal} from "react-bootstrap";
import InvoicePaymentForm from "../ClientPortal/InvoicePaymentForm";
import TipModal from "../ClientPortal/TipModal";

export default () => {
    let Record = useContext(RecordsManagementContext)
    let ClientPortalHeader = Record.CP_PageDetails.ClientPortalHeader
    let InvoicePayment = ClientPortalHeader.InvoicePayment
    const hideInvoicePaymentModal = () => {
        Record.setInvoicePaymentModal(false) //close pay deposit modal
    }

    const Button = (props) => {
        if (props.Show) {
            return (
                <div className={props.ClsName}
                     onClick={() => showTipModal()}>
                    <b>{props.For}</b>
                </div>
            )
        } else {
            return (<></>)
        }
    }

    const showTipModal = () => {
        if (tipAmount()) {
            Record.setCrewTipModal(true)
            Record.setTipforCrew(false)
        } else {
            Record.setInvoicePaymentModal(true)
        }

    }

    const tipAmount = () => {
        if(Record.IV2_PageDetails.JobDetails.Tip.Value !== undefined) {
            if (Record.IV2_PageDetails.JobDetails.Tip.Value <= 0 && Record.Tip == '' && ClientPortalHeader.InvoicePayment.IsBilledJob) {
                return true;
            } else {
                return false;
            }
        }else if(Record.IV1_PageDetails.Tip !== undefined){
            if (Record.IV1_PageDetails.Tip <= 0 && Record.Tip == '' && ClientPortalHeader.InvoicePayment.IsBilledJob) {
                return true;
            } else {
                return false;
            }
        }
    }

    const hideCrewTipModal = () =>{
        Record.setCrewTipModal(false) //close crew tip modal
        Record.setInvoicePaymentModal(true)
    }

    return (
        <>
            <Button
                ClsName="btn btn-dark btn-sm"
                Show={(((InvoicePayment.EnableInvoicePayment && InvoicePayment.IsBolSubmited) ||
                    InvoicePayment.IsBilledJob) && InvoicePayment.DueBalance > 0 && InvoicePayment.HasPaymentGateway)}
                For='PAY MY INVOICE'/>
            <Modal show={Record.InvoicePaymentModal} onHide={() => hideInvoicePaymentModal()}
                   style={{top: "9%"}}
            >
                <Modal.Header><h5 style={{color: "#37abdb", fontSize: "15px", fontWeight: 600}}>
                    Invoice Payment </h5>
                    <button onClick={() => hideInvoicePaymentModal()}
                            style={{color: "red", background: "white", border: "white", height: "5%"}}>
                        <b className="contactInfoCloseBtn">X</b></button>
                </Modal.Header>
                <Modal.Body style={{minHeight: 545, maxHeight: 700, overflowY: "scroll"}}>
                    <InvoicePaymentForm  FormatVisible={Record.FormatVisible} Tip={Record.Tip}/>
                </Modal.Body>
            </Modal>

            <TipModal/>
        </>

    )
}